import React from 'react';

export const Result = ({resultCheck}) => {
    let {controle, rvo, rvodetails } = resultCheck
    return (
        <div className="result">

            {controle && controle !== '' &&
                <div className="result__content controle">
                    <div className="result__label">
                        Resultaat:
                    </div>
                    {controle}
                </div>
            }
            {rvo && rvo !== '' &&
                <div className="result__content rvo">
                    <div className="result__label">
                        Landelijke ontheffingen en vrijstellingen:
                    </div>
                    {rvo}
                </div>
            }
            {rvodetails && rvodetails !== '' &&
                <div className="result__content rvoDetails">
                    <div className="result__label">
                        Details:
                    </div>
                    {rvodetails}
                </div>
            }
        </div>
    );
}
